import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import "./globals.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { I18nextProvider } from "react-i18next";

import { SvThemeProvider } from "@/components/SvThemeProvider.tsx";
import { i18n } from "@/i18n";
import { initSentry } from "@/services/sentry";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
const router = createRouter({ routeTree, scrollRestoration: true });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router;
  }
}

initSentry();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * (60 * 1000), // 30 minutes
      gcTime: 60 * (60 * 1000), // 1 hour
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SvThemeProvider defaultTheme="light" storageKey="smartvoting-theme">
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <RouterProvider router={router} />
        </I18nextProvider>
      </QueryClientProvider>
    </SvThemeProvider>
  </StrictMode>,
);
